import { Fragment, Suspense, useEffect } from 'react';
import { Outlet } from 'react-router';
import ChatbotFloating from '@/components/Helper/chatbot';
import Header from '@/components/Header/index';
import { SidebarProvider } from '@/components/ui/sidebar';
import { AppSidebar } from '@/components/Sidebar/app-sidebar';
import { usePermission } from '@/services/permission.service';
import { useRootSelector } from '@/hooks/selector.hook';

export default function MainLayout() {
  const { getAllMenuPermission } = usePermission();
  const customerId = useRootSelector((state) => state.auth.customerId);
  const dataMenu = useRootSelector((state) => state.permission.menuItems);
  // Gọi API permission khi layout mount và có customerId
  useEffect(() => {
    if (customerId) {
      getAllMenuPermission();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerId]); // Chỉ depend vào customerId, không depend vào getAllMenuPermission để tránh re-render

  return (
    <Fragment>
      <div className="min-h-screen bg-[#FFFFFF] dark:bg-[#000000] overflow-x-hidden">
        <SidebarProvider>
          <AppSidebar data={dataMenu} />
          <div className="w-full lg:ml-[2.5rem] lg:mt-[1.5rem] overflow-x-hidden">
            <div className="transition-all duration-300 min-h-screen">
              {/* Header */}
              <Header />

              {/* Page Content */}
              <main className="pt-[2rem] lg:pt-0 px-[1rem] md:px-[2rem] pb-[2rem]">
                <Suspense
                  fallback={
                    <div className="flex items-center justify-center h-64">
                      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
                    </div>
                  }
                >
                  <Outlet />
                </Suspense>
              </main>
              <ChatbotFloating />
            </div>
          </div>
        </SidebarProvider>
      </div>
    </Fragment>
  );
}
